import { render, staticRenderFns } from "./ReferralCard.vue?vue&type=template&id=9d6a687a"
import script from "./ReferralCard.vue?vue&type=script&lang=js"
export * from "./ReferralCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports